<app-header [currentModule]="moduloEnum" [currentModuleFuncionality]="funcionalidadeEnum"></app-header>

<div class="container-header">
  <div class="container-header-inner">
    <div class="row">
      <div class="col-12">
        <!-- Badge FORA do h1, como no cadastro da NF-e de entrada: dentro dele herdaria o
             `line-height: 38px` do `.title-default` e a pilula sairia alta e desalinhada. -->
        <div class="titulo-linha">
          <h1 class="title-default">{{ titulo }}</h1>

          <!-- §1.2: o badge da etapa e INFORMATIVO. Quem movimenta e o campo Etapa (§9),
               na secao Dados; aqui o usuario so precisa saber em que etapa esta. -->
          @if (etapaAtual) {
            <span class="status-badge" [style.background]="corEtapa?.fundo" [style.color]="corEtapa?.conteudo">
              @if (iconeEtapa) {
                <mat-icon class="material-symbols-outlined">{{ iconeEtapa }}</mat-icon>
              }
              {{ etapaAtual.nome }}
            </span>
          }

          <!-- Menu Ações (task 148619): chama os fluxos que já existem — etapa, clonar, criar
               modelo, histórico. Só para documento gravado; itens indisponíveis ficam
               desabilitados com o motivo, não somem. -->
          @if (exibeMenuDeAcoes) {
            <button type="button" class="vdac-botao" [matMenuTriggerFor]="menuAcoes">
              Ações
              <mat-icon class="material-symbols-outlined">expand_more</mat-icon>
            </button>

            <mat-menu #menuAcoes="matMenu" class="vdac-menu" xPosition="before">
              <!-- Escondido só no encerramento: documento com lançamentos ainda muda de etapa. -->
              @if (!isEncerrado) {
                <span [matTooltip]="tooltipAlterarEtapa" matTooltipPosition="left">
                  <button type="button" mat-menu-item [disabled]="!destinosDeEtapa.length" (click)="acaoAlterarEtapa()">
                    <mat-icon class="material-symbols-outlined">swap_horiz</mat-icon>
                    <span>Alterar etapa</span>
                  </button>
                </span>
              }

              <button type="button" mat-menu-item [disabled]="!podeClonar" (click)="acaoClonar()">
                <mat-icon class="material-symbols-outlined">content_copy</mat-icon>
                <span>{{ rotuloClonar }}</span>
              </button>

              <!-- Gerar PDF (§11.1) lê o documento gravado: não exige Alterar e vale também no encerrado.
                   Modelo não é documento para o cliente: nem PDF nem link. -->
              @if (exibeGerarPdfECompartilhar) {
                <button type="button" mat-menu-item (click)="acaoGerarPdf()">
                  <mat-icon class="material-symbols-outlined">picture_as_pdf</mat-icon>
                  <span>Gerar PDF</span>
                </button>

                <span [matTooltip]="tooltipCompartilhar" matTooltipPosition="left">
                  <button type="button" mat-menu-item [disabled]="!podeCompartilhar" (click)="acaoCompartilhar()">
                    <mat-icon class="material-symbols-outlined">share</mat-icon>
                    <span>Compartilhar</span>
                  </button>
                </span>
              }

              @if (exibeCriarModelo) {
                <button type="button" mat-menu-item [disabled]="!podeCriarModelo" (click)="acaoCriarModelo()">
                  <mat-icon class="material-symbols-outlined">content_paste</mat-icon>
                  <span>Criar modelo</span>
                </button>
              }

              <!-- Financeiro (T05/T08): só no pedido gravado. Lançar lê o documento GRAVADO: com alteração
                   pendente fica desabilitado até salvar. Excluir exige a permissão própria (215). -->
              @if (exibeLancarFinanceiro) {
                <span [matTooltip]="tooltipLancarFinanceiro" matTooltipPosition="left">
                  <button type="button" mat-menu-item [disabled]="!podeLancarFinanceiro" (click)="acaoLancarFinanceiro()">
                    <mat-icon class="material-symbols-outlined">payments</mat-icon>
                    <span>Lançar financeiro</span>
                  </button>
                </span>
              }
              @if (exibeExcluirFinanceiro) {
                <span [matTooltip]="tooltipExcluirFinanceiro" matTooltipPosition="left">
                  <button type="button" mat-menu-item [disabled]="!podeExcluirFinanceiro" (click)="acaoExcluirFinanceiro()">
                    <mat-icon class="material-symbols-outlined">money_off</mat-icon>
                    <span>Excluir financeiro</span>
                  </button>
                </span>
              }

              <!-- Estoque (T10/T11): só no pedido gravado. Lançar lê o documento GRAVADO: com alteração
                   pendente fica desabilitado até salvar. Excluir exige a permissão própria (216). -->
              @if (exibeLancarEstoque) {
                <span [matTooltip]="tooltipLancarEstoque" matTooltipPosition="left">
                  <button type="button" mat-menu-item [disabled]="!podeLancarEstoque" (click)="acaoLancarEstoque()">
                    <mat-icon class="material-symbols-outlined">inventory_2</mat-icon>
                    <span>Lançar estoque</span>
                  </button>
                </span>
              }
              @if (exibeExcluirEstoque) {
                <span [matTooltip]="tooltipExcluirEstoque" matTooltipPosition="left">
                  <button type="button" mat-menu-item [disabled]="!podeExcluirEstoque" (click)="acaoExcluirEstoque()">
                    <mat-icon class="material-symbols-outlined">undo</mat-icon>
                    <span>Excluir estoque</span>
                  </button>
                </span>
              }

              <button type="button" mat-menu-item (click)="abrirHistorico()">
                <mat-icon class="material-symbols-outlined">history</mat-icon>
                <span>Ver histórico</span>
              </button>

              <!-- Excluir (T15, §10): a mesma exclusão do menu do card, com a permissão própria. -->
              <span [matTooltip]="tooltipExcluirDocumento" matTooltipPosition="left">
                <button type="button" mat-menu-item [disabled]="!podeExcluirDocumento" (click)="acaoExcluirDocumento()">
                  <mat-icon class="material-symbols-outlined">delete</mat-icon>
                  <span>{{ rotuloExcluir }}</span>
                </button>
              </span>

              <!-- Grupo da oportunidade (D3, RX-01 a RX-06), com as mesmas regras do card do Processo de Venda:
                   os itens sempre aparecem; sem Visualizar do CRM ficam desativados com o tooltip da RX-05. -->
              @let acoes = acoesOportunidade;
              <mat-divider></mat-divider>
              @if (exibeItensDeOportunidade) {
                @if (documento?.idOportunidade != null) {
                  @if (documento?.isOportunidadeForaDoEscopo) {
                    <span [matTooltip]="tooltipOportunidadeOutroVendedor" matTooltipPosition="left">
                      <button type="button" mat-menu-item disabled [attr.aria-label]="tooltipOportunidadeOutroVendedor">
                        <mat-icon class="material-symbols-outlined">lock</mat-icon>
                        <span>Oportunidade de outro vendedor</span>
                      </button>
                    </span>
                  } @else {
                    <span [matTooltip]="acoes.motivoVer" matTooltipPosition="left">
                      <button type="button" mat-menu-item [disabled]="!!acoes.motivoVer"
                        [attr.aria-label]="acoes.motivoVer || null" (click)="verOportunidade()">
                        <mat-icon class="material-symbols-outlined">handshake</mat-icon>
                        <span>{{ acoes.rotuloVer }}</span>
                      </button>
                    </span>
                    <span [matTooltip]="acoes.motivoDesvincular" matTooltipPosition="left">
                      <button type="button" mat-menu-item [disabled]="!!acoes.motivoDesvincular"
                        [attr.aria-label]="acoes.motivoDesvincular || null" (click)="desvincularOportunidade()">
                        <mat-icon class="material-symbols-outlined">link_off</mat-icon>
                        <span>Desvincular da oportunidade</span>
                      </button>
                    </span>
                  }
                } @else {
                  <span [matTooltip]="acoes.motivoCriar" matTooltipPosition="left">
                    <button type="button" mat-menu-item [disabled]="!!acoes.motivoCriar"
                      [attr.aria-label]="acoes.motivoCriar || null" (click)="criarOportunidade()">
                      <mat-icon class="material-symbols-outlined">add_comment</mat-icon>
                      <span>Criar oportunidade</span>
                    </button>
                  </span>
                  <span [matTooltip]="acoes.motivoVincular" matTooltipPosition="left">
                    <button type="button" mat-menu-item [disabled]="!!acoes.motivoVincular"
                      [attr.aria-label]="acoes.motivoVincular || null" (click)="vincularOportunidade()">
                      <mat-icon class="material-symbols-outlined">add_link</mat-icon>
                      <span>Vincular a oportunidade</span>
                    </button>
                  </span>
                }
              }

              <span [matTooltip]="acoes.motivoVerDoCliente" matTooltipPosition="left">
                <button type="button" mat-menu-item [disabled]="!!acoes.motivoVerDoCliente"
                  [attr.aria-label]="acoes.motivoVerDoCliente || null" (click)="verOportunidadesCliente()">
                  <mat-icon class="material-symbols-outlined">forum</mat-icon>
                  <span>Ver oportunidades do cliente</span>
                </button>
              </span>
            </mat-menu>
          }
        </div>
        <p class="welcome-message">
          <button class="icon-mat-symbols-btn" mat-icon-button type="button" (click)="voltar()">
            <mat-icon>arrow_back</mat-icon>
          </button>
          {{ ehOrcamento ? 'Proposta comercial para o cliente.' : 'Pedido de venda do cliente.' }}

          @if (idVenda != null) {
            <button mat-button type="button" class="link-historico" (click)="abrirHistorico()">
              Ver histórico
            </button>
          }
        </p>
      </div>
    </div>

    @if (isLoading) {
      <div class="section-container">
        <app-loading-box height="30" width="220" marginTop="0"></app-loading-box>
        <app-loading-box height="22" width="55%" marginTop="16"></app-loading-box>
        <app-loading-box height="22" width="48%" marginTop="12"></app-loading-box>
      </div>
      <div class="section-container">
        <app-loading-box height="30" width="180" marginTop="0"></app-loading-box>
        <app-loading-box height="150" width="100%" marginTop="16"></app-loading-box>
      </div>
      <div class="section-container">
        <app-loading-box height="30" width="160" marginTop="0"></app-loading-box>
        <app-loading-box height="120" width="100%" marginTop="16"></app-loading-box>
      </div>
    } @else {
      <!-- §1.4: documento encerrado ou com lançamentos abre inteiro em leitura, e a faixa diz por que. -->
      @if (isSomenteLeitura) {
        <app-alert-card type="info" [title]="tituloSomenteLeitura" class="vd-faixa-leitura">
          {{ motivoSomenteLeitura }}
          @if (isFinanceiroLancado) {
            <div alertActions>
              <button mat-button type="button" class="btn-section" (click)="acaoVerLancamentos()">Ver lançamentos</button>
            </div>
          }
        </app-alert-card>
      }

      <!-- Clonar (148656): o documento ainda não existe — nasce no salvar. -->
      @if (rotuloOrigem && idVenda == null) {
        <app-alert-card type="info" title="Cópia" class="vd-faixa-leitura">
          Cópia do {{ rotuloOrigem }}. Revise e salve para gerar o novo documento — ele nasce na etapa
          inicial, com número novo e preços da lista vigente — sem recebimentos, anexos e liberações do original.
        </app-alert-card>
      }

      <!-- Ficha do CRM (150708): o documento ainda não existe — nasce no salvar, ligado à oportunidade. -->
      @if (oportunidadeOrigem && idVenda == null) {
        <app-alert-card type="info" title="Lançamento iniciado a partir da oportunidade do CRM" class="vd-faixa-leitura">
          Documento iniciado a partir da oportunidade #{{ oportunidadeOrigem.codigo }} — {{ oportunidadeOrigem.titulo }}.
        </app-alert-card>
      }

      <!-- Ações do cadastro de Pessoa (150696): o documento ainda não existe — nasce no salvar. -->
      @if (isOrigemPessoa && idVenda == null) {
        <app-alert-card type="info" title="Lançamento iniciado a partir do cadastro de Pessoa" class="vd-faixa-leitura">
          O cliente veio preenchido e o documento está em branco.
        </app-alert-card>
      }

      <!-- §15: o que impediu o salvar, com o caminho até a seção onde cada pendência se resolve. -->
      @if (pendenciasDoSalvar.length > 0) {
        <app-alert-card type="warning" title="Pendências para salvar" class="vd-faixa-leitura" [closable]="true"
          (close)="pendenciasDoSalvar = []">
          <ul class="vd-pendencias">
            @for (pendencia of pendenciasDoSalvar; track pendencia.titulo) {
              <li>
                <strong>{{ pendencia.titulo }}:</strong> {{ pendencia.mensagem }}
                <button type="button" mat-button class="btn-link vd-pendencia-link" (click)="irParaSecao(pendencia.secao)">
                  Ir para a seção
                </button>
              </li>
            }
          </ul>
        </app-alert-card>
      }

      <form [formGroup]="form">
        <app-page-scroll-spy #barraSecoes [sections]="sections" (sectionSelected)="aoSelecionarSecao($event)"></app-page-scroll-spy>

        <!-- Todas as seções recolhem: o conteúdo fica oculto por [hidden], nunca destruído, e o
             menu lateral expande a seção antes de rolar até ela. -->

        <!-- ================= 1. Dados gerais ================= -->
        <div class="section-container" id="dados">
          <div class="section-title">
            <button type="button" class="section-collapse-trigger" (click)="alternarSecao('dados')" [attr.aria-expanded]="!isRecolhida('dados')">
              <mat-icon class="material-symbols-outlined">receipt_long</mat-icon>
              <span>Dados gerais</span>
            </button>
            <button type="button" class="section-collapse-button" (click)="alternarSecao('dados')"
              [attr.aria-label]="isRecolhida('dados') ? 'Expandir seção Dados gerais' : 'Minimizar seção Dados gerais'">
              <mat-icon class="material-symbols-outlined">{{ isRecolhida('dados') ? 'expand_more' : 'expand_less' }}</mat-icon>
            </button>
          </div>
          <div [hidden]="isRecolhida('dados')">
            <app-vd-dados
              [form]="form"
              [ehOrcamento]="ehOrcamento"
              [vendedores]="vendedores"
              [clienteSelecionado]="clienteSelecionado"
              [motivoClienteBloqueado]="motivoClienteBloqueado"
              [configVendasGeral]="configVendasGeral"
              [configOrcamento]="configOrcamento"
              [configPedidoVenda]="configPedidoVenda"
              [mascaraInteira]="mascaraInteira"
              [isSomenteLeitura]="isSomenteLeitura"
              [coresKanban]="coresKanban"
              [ehNovo]="idVenda == null"
              [cadastradoEm]="documento?.datetimeInclusao ?? null"
              [pedidoAbrirEtapa]="pedidoAbrirEtapa"
              [etapaAtual]="etapaAtual"
              [corEtapa]="corEtapa"
              [iconeEtapa]="iconeEtapa"
              [destinosDeEtapa]="destinosDeEtapa"
              [isMovendoEtapa]="isMovendoEtapa"
              (moverEtapa)="moverEtapa($event)"
              (nomeListaPrecoAlterado)="nomeListaPrecoSelecionada = $event"
              (clienteFinanceiro)="aoReceberClienteFinanceiro($event)"
              (clienteEscolhido)="aoEscolherCliente()"
              (recalcularPrecos)="pedidoRecalcularPrecos = pedidoRecalcularPrecos + 1"
              (historicoCliente)="aplicarTagPrimeiraVenda($event)">
            </app-vd-dados>
          </div>
        </div>

        <!-- ================= 2. Introdução [ORC] ================= -->
        @if (ehOrcamento) {
          <div class="section-container" id="introducao">
            <div class="section-title">
              <button type="button" class="section-collapse-trigger" (click)="alternarSecao('introducao')" [attr.aria-expanded]="!isRecolhida('introducao')">
                <mat-icon class="material-symbols-outlined">notes</mat-icon>
                <span>Introdução</span>
              </button>
              <button type="button" class="section-collapse-button" (click)="alternarSecao('introducao')"
                [attr.aria-label]="isRecolhida('introducao') ? 'Expandir seção Introdução' : 'Minimizar seção Introdução'">
                <mat-icon class="material-symbols-outlined">{{ isRecolhida('introducao') ? 'expand_more' : 'expand_less' }}</mat-icon>
              </button>
            </div>
            <div [hidden]="isRecolhida('introducao')">
              <app-vd-introducao
                [form]="form"
                [configOrcamento]="configOrcamento"
                [isSomenteLeitura]="isSomenteLeitura">
              </app-vd-introducao>
            </div>
          </div>
        }

        <!-- ================= 3. Itens ================= -->
        <div class="section-container" id="itens">
          <div class="section-title">
            <button type="button" class="section-collapse-trigger" (click)="alternarSecao('itens')" [attr.aria-expanded]="!isRecolhida('itens')">
              <mat-icon class="material-symbols-outlined">shopping_cart</mat-icon>
              <span>{{ ehOrcamento ? 'Itens do orçamento' : 'Itens da venda' }}</span>
              @if (quantidadeDeItens > 0) {
                <span class="status-badge badge-cinza">{{ quantidadeDeItens }}</span>
              }
            </button>
            <button type="button" class="section-collapse-button" (click)="alternarSecao('itens')"
              [attr.aria-label]="isRecolhida('itens') ? 'Expandir seção de itens' : 'Minimizar seção de itens'">
              <mat-icon class="material-symbols-outlined">{{ isRecolhida('itens') ? 'expand_more' : 'expand_less' }}</mat-icon>
            </button>
          </div>
          <!-- Oculta por CSS, e não removida: a grade guarda estado de sessão (linha em edição, kits recolhidos). -->
          <div [hidden]="isRecolhida('itens')">
            <app-vd-itens
              [form]="form"
              [mascaraPreco]="mascaraPreco"
              [mascaraQuantidade]="mascaraQuantidade"
              [mascaraInteira]="mascaraInteira"
              [mascaraPercentual]="mascaraPercentual"
              [ehOrcamento]="ehOrcamento"
              [calcularImpostos]="calcularImpostos"
              [exibeDescontoPorItem]="exibeDescontoPorItem"
              [tetoDesconto]="tetoDesconto"
              [valorDescontoGlobal]="valorDescontoGlobal"
              [idListaCabecalho]="idListaCabecalho"
              [priorizarMenorPreco]="priorizarMenorPreco"
              [idNatOpCabecalho]="idNatOpCabecalho"
              [vendedor]="vendedorSelecionado"
              [coresKanban]="coresKanban"
              [tipoValidacaoEstoqueNegativo]="tipoValidacaoEstoqueNegativo"
              [idVenda]="idVenda"
              [localizacoesEstoque]="localizacoesEstoque"
              [reprecificarAoCarregar]="idVendaOrigem != null && idVenda == null"
              [pedidoRecalcularPrecos]="pedidoRecalcularPrecos"
              [itensDoDocumento]="itensDoDocumento"
              [exigeLiberacaoParaRemover]="idVenda != null && !podeRemoverItem"
              (liberacaoRemocao)="credencialRemocao = $event"
              [isSomenteLeitura]="isSomenteLeitura">
            </app-vd-itens>
          </div>
        </div>

        <!-- ================= 4. Tributos ================= -->
        <!-- §7.1: com o cálculo de impostos DESLIGADO nenhum campo de imposto é renderizado. -->
        @if (calcularImpostos) {
          <div class="section-container" id="tributos">
            <div class="section-title">
              <button type="button" class="section-collapse-trigger" (click)="alternarSecao('tributos')" [attr.aria-expanded]="!isRecolhida('tributos')">
                <mat-icon class="material-symbols-outlined">account_balance</mat-icon>
                <span>Tributos</span>
              </button>
              <button type="button" class="section-collapse-button" (click)="alternarSecao('tributos')"
                [attr.aria-label]="isRecolhida('tributos') ? 'Expandir seção Tributos' : 'Minimizar seção Tributos'">
                <mat-icon class="material-symbols-outlined">{{ isRecolhida('tributos') ? 'expand_more' : 'expand_less' }}</mat-icon>
              </button>
            </div>
            <div [hidden]="isRecolhida('tributos')">
              <app-vd-tributos [form]="form"></app-vd-tributos>
            </div>
          </div>
        }

        <!-- ================= 5. Totais ================= -->
        <div class="section-container" id="totais">
          <div class="section-title">
            <button type="button" class="section-collapse-trigger" (click)="alternarSecao('totais')" [attr.aria-expanded]="!isRecolhida('totais')">
              <mat-icon class="material-symbols-outlined">summarize</mat-icon>
              <span>Totais</span>
            </button>
            <button type="button" class="section-collapse-button" (click)="alternarSecao('totais')"
              [attr.aria-label]="isRecolhida('totais') ? 'Expandir seção Totais' : 'Minimizar seção Totais'">
              <mat-icon class="material-symbols-outlined">{{ isRecolhida('totais') ? 'expand_more' : 'expand_less' }}</mat-icon>
            </button>
          </div>
          <div [hidden]="isRecolhida('totais')">
            <app-vd-totais
              [form]="form"
              [ehOrcamento]="ehOrcamento"
              [isSomenteLeitura]="isSomenteLeitura"
              [tetoDesconto]="tetoDesconto"
              [mascaraDinheiro]="mascaraDinheiro"
              [mascaraPercentual]="mascaraPercentual">
            </app-vd-totais>
          </div>
        </div>

        <!-- ================= 6. Pagamento ================= -->
        <!-- A MESMA secao nos dois documentos (Pedro, 24/09): a unica diferenca e que o pedido exige
             recebimentos (configuracao) e o orcamento nao - e isso mora na validacao do salvar. -->
        <div class="section-container" id="pagamento">
          <div class="section-title">
            <button type="button" class="section-collapse-trigger" (click)="alternarSecao('pagamento')" [attr.aria-expanded]="!isRecolhida('pagamento')">
              <mat-icon class="material-symbols-outlined">payments</mat-icon>
              <span>Pagamento</span>
            </button>
            <button type="button" class="section-collapse-button" (click)="alternarSecao('pagamento')"
              [attr.aria-label]="isRecolhida('pagamento') ? 'Expandir seção Pagamento' : 'Minimizar seção Pagamento'">
              <mat-icon class="material-symbols-outlined">{{ isRecolhida('pagamento') ? 'expand_more' : 'expand_less' }}</mat-icon>
            </button>
          </div>
          <div [hidden]="isRecolhida('pagamento')">
            <app-vd-pagamento
              [form]="form"
              [ehOrcamento]="ehOrcamento"
              [totalDoDocumento]="totalDoDocumento"
              [ehDocumentoNovo]="idVenda == null"
              [financas]="financas"
              [isCondicaoPagamentoLivre]="configVendasGeral?.isCondicaoPagamentoLivre === true"
              [isSomenteLeitura]="isSomenteLeitura"
              [isNsuObrigatorio]="isNsuObrigatorio"
              [isObservacaoParcelaObrigatoria]="isObservacaoParcelaObrigatoria"
              [mascaraDinheiro]="mascaraDinheiro"
              [mascaraPercentual]="mascaraPercentual"
              [mascaraInteira]="mascaraInteira">
            </app-vd-pagamento>
          </div>
        </div>

        <!-- ================= 7. Transporte ================= -->
        @if (exibeTransporte) {
          <div class="section-container" id="transporte">
            <div class="section-title">
              <button type="button" class="section-collapse-trigger" (click)="alternarSecao('transporte')" [attr.aria-expanded]="!isRecolhida('transporte')">
                <mat-icon class="material-symbols-outlined">local_shipping</mat-icon>
                <span>Transporte</span>
              </button>
              <button type="button" class="section-collapse-button" (click)="alternarSecao('transporte')"
                [attr.aria-label]="isRecolhida('transporte') ? 'Expandir seção Transporte' : 'Minimizar seção Transporte'">
                <mat-icon class="material-symbols-outlined">{{ isRecolhida('transporte') ? 'expand_more' : 'expand_less' }}</mat-icon>
              </button>
            </div>
            <div [hidden]="isRecolhida('transporte')">
              <app-vd-transporte
                [form]="form"
                [ehOrcamento]="ehOrcamento"
                [ehNovo]="idVenda == null"
                [isSomenteLeitura]="isSomenteLeitura"
                [formasEnvio]="formasEnvio"
                [nomeTransportadorGravado]="documento?.nomePessoaTransportador ?? null"
                [exibeExpedicao]="trabalhaComExpedicao"
                [mascaraInteira]="mascaraInteira">
              </app-vd-transporte>
            </div>
          </div>
        }

        <!-- ================= 8. Assinatura [ORC] ================= -->
        @if (ehOrcamento) {
          <div class="section-container" id="assinatura">
            <div class="section-title">
              <button type="button" class="section-collapse-trigger" (click)="alternarSecao('assinatura')" [attr.aria-expanded]="!isRecolhida('assinatura')">
                <mat-icon class="material-symbols-outlined">draw</mat-icon>
                <span>Assinatura</span>
              </button>
              <button type="button" class="section-collapse-button" (click)="alternarSecao('assinatura')"
                [attr.aria-label]="isRecolhida('assinatura') ? 'Expandir seção Assinatura' : 'Minimizar seção Assinatura'">
                <mat-icon class="material-symbols-outlined">{{ isRecolhida('assinatura') ? 'expand_more' : 'expand_less' }}</mat-icon>
              </button>
            </div>
            <div [hidden]="isRecolhida('assinatura')">
              <app-vd-assinatura
                [form]="form"
                [configOrcamento]="configOrcamento"
                [isSomenteLeitura]="isSomenteLeitura">
              </app-vd-assinatura>
            </div>
          </div>
        }

        <!-- ================= 9. Dados adicionais ================= -->
        @if (exibeAdicionais) {
          <div class="section-container" id="adicionais">
            <div class="section-title">
              <button type="button" class="section-collapse-trigger" (click)="alternarSecao('adicionais')" [attr.aria-expanded]="!isRecolhida('adicionais')">
                <mat-icon class="material-symbols-outlined">notes</mat-icon>
                <span>Dados adicionais</span>
              </button>
              <button type="button" class="section-collapse-button" (click)="alternarSecao('adicionais')"
                [attr.aria-label]="isRecolhida('adicionais') ? 'Expandir seção Dados adicionais' : 'Minimizar seção Dados adicionais'">
                <mat-icon class="material-symbols-outlined">{{ isRecolhida('adicionais') ? 'expand_more' : 'expand_less' }}</mat-icon>
              </button>
            </div>
            <div [hidden]="isRecolhida('adicionais')">
              <app-vd-adicionais
                [form]="form"
                [ehOrcamento]="ehOrcamento"
                [tags]="tags"
                [isSomenteLeitura]="isSomenteLeitura">
              </app-vd-adicionais>
            </div>
          </div>
        }

        <!-- ================= 10. Anexos ================= -->
        <div class="section-container" id="anexos">
          <div class="section-title">
            <button type="button" class="section-collapse-trigger" (click)="alternarSecao('anexos')" [attr.aria-expanded]="!isRecolhida('anexos')">
              <mat-icon class="material-symbols-outlined">attach_file</mat-icon>
              <span>Anexos</span>
            </button>
            <button type="button" class="section-collapse-button" (click)="alternarSecao('anexos')"
              [attr.aria-label]="isRecolhida('anexos') ? 'Expandir seção Anexos' : 'Minimizar seção Anexos'">
              <mat-icon class="material-symbols-outlined">{{ isRecolhida('anexos') ? 'expand_more' : 'expand_less' }}</mat-icon>
            </button>
          </div>
          <div [hidden]="isRecolhida('anexos')">
            <app-vd-anexos
              [anexos]="anexos"
              [isSomenteLeitura]="isSomenteLeitura"
              (anexosChange)="anexos = $event">
            </app-vd-anexos>
          </div>
        </div>
      </form>

      <!-- ================= 12. Histórico ================= -->
      <!-- Fora do form: a linha do tempo usa ngModel, que não convive com o formGroup pai. Só no
           documento gravado: o histórico nasce no primeiro salvar. -->
      @if (idVenda != null) {
        <app-vd-historico
          [idVenda]="idVenda"
          [podeAlterar]="podeAlterarHistorico"
          [bloquearExclusaoOcorrencia]="bloquearExclusaoOcorrencia"
          [pedidoRecarregar]="pedidoRecarregarHistorico">
        </app-vd-historico>
      }
    }
  </div>
</div>

<!-- §1.4: em leitura o Salvar nao e exibido; sobra o Voltar. -->
<app-footer-action
  [isLoadingSalvar]="isSalvando"
  [isSalvarDisabled]="isLoading"
  [hideSalvar]="isSomenteLeitura"
  [cancelarLabel]="isSomenteLeitura ? 'Voltar' : 'Cancelar'"
  (salvar)="salvar()"
  (cancelar)="voltar()">
</app-footer-action>
